// src/index.js
import React from "react";
import ReactDOM from "react-dom/client";
import { Provider } from "react-redux";
import { store } from "./redux/store";
import App from "./App";
import { setupGlobalErrorHandling } from "./utils/errorHandler";
import { logger } from "./services/logger";

import "swiper/css";
import "aos";
import "aos/dist/aos.css";
import "react-tooltip/dist/react-tooltip.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-big-calendar/lib/css/react-big-calendar.css";
import "react-datepicker/dist/react-datepicker.css";
import "react-modern-drawer/dist/index.css";

// Configurar manejo global de errores
setupGlobalErrorHandling();

const root = ReactDOM.createRoot(document.getElementById("root"));

try {
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  );

  logger.info("React application rendered successfully");
} catch (error) {
  logger.error(error, {
    component: "index.js",
    additionalData: {
      phase: "initial-render",
    },
  });

  const errorElement = document.createElement("div");
  errorElement.style.cssText = `
    padding: 20px;
    background: #f8d7da;
    color: #721c24;
    border: 1px solid #f5c6cb;
    border-radius: 4px;
    margin: 20px;
    font-family: Arial, sans-serif;
  `;
  errorElement.innerHTML = `
    <h2>⚠️ Error crítico en la aplicación</h2>
    <p>No se pudo cargar la aplicación. Por favor recarga la página.</p>
    <button onclick="window.location.reload()" style="
      background: #007bff;
      color: white;
      border: none;
      padding: 10px 20px;
      border-radius: 4px;
      cursor: pointer;
    ">Recargar página</button>
  `;

  document.body.appendChild(errorElement);
}
